/* import __COLOCATED_TEMPLATE__ from './clinician-select-therapyfinder-embed.hbs'; */
import { classNames } from '@ember-decorators/component';
import RequestClinicianSelect from './clinician-select';
import styles from './clinician-select-therapyfinder-embed.module.scss';

@classNames('clinician-select text-left justify-content-between', styles.component)
export default class RequestClinicianSelectTherapyfinderEmbed extends RequestClinicianSelect {
  styles = styles;
}
